const DEFAULT_TRUTHY_VALUES: unknown[] = [true, 'true', 1, '1'];

export function parseBoolean(
  rawValue: unknown,
  additionalTruthyValues: unknown[] = [],
): boolean {
  return (
    DEFAULT_TRUTHY_VALUES.includes(rawValue) ||
    additionalTruthyValues.includes(rawValue)
  );
}
